(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["event_product_block"] && !Shopify.designMode) return;
  try {
    (function () {


  if (window.eventProductValidationInstalled) {
    return;
  }

  window.eventProductValidationInstalled = true;

  const gmailMistakes = [
    'gmial.com',
    'gamil.com',
    'gmai.com',
    'gmal.com',
    'gmail.co',
    'gmail.c',
    'gmail.con',
    'gmail.cmo',
    'gmail.om',
    'gmail.co.za'
  ];

  function getElements(input) {
    const block = input.closest('[data-event-product-block]');

    if (!block) {
      return null;
    }

    return {
      block: block,
      emailError: block.querySelector('[data-email-error]'),
      phoneError: block.querySelector('[data-phone-error]')
    };
  }

  function setError(input, output, message) {
    input.setCustomValidity(message);
    input.classList.add('invalid');
    input.classList.remove('valid');

    if (output) {
      output.textContent = message;
      output.style.color = '#b00020';
    }

    return false;
  }

  function setValid(input, output) {
    input.setCustomValidity('');
    input.classList.add('valid');
    input.classList.remove('invalid');

    if (output) {
      output.textContent = 'Valid format';
      output.style.color = '#198754';
    }

    return true;
  }

  function clearResult(input, output) {
    input.setCustomValidity('');
    input.classList.remove('valid', 'invalid');

    if (output) {
      output.textContent = '';
    }
  }

  function validateEmail(input) {
    const elements = getElements(input);

    if (!elements) {
      return false;
    }

    const output = elements.emailError;
    const email = input.value.trim().toLowerCase();
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (email === '') {
      clearResult(input, output);
      return false;
    }

    if (!emailPattern.test(email)) {
      return setError(
        input,
        output,
        'Please enter a valid email address.'
      );
    }

    const atPosition = email.lastIndexOf('@');
    const username = email.substring(0, atPosition);
    const domain = email.substring(atPosition + 1);

    if (gmailMistakes.includes(domain)) {
      return setError(
        input,
        output,
        'Did you mean ' + username + '@gmail.com?'
      );
    }

    const suspiciousGmailPattern =
      /^(gmail|gmial|gamil|gmai|gmal)\.(com|con|cmo|co|c|om|co\.za)$/;

    if (
      domain !== 'gmail.com' &&
      suspiciousGmailPattern.test(domain)
    ) {
      return setError(
        input,
        output,
        'Did you mean ' + username + '@gmail.com?'
      );
    }


    if (
      domain === 'gmail.com' &&
      !/^[a-z0-9.]+$/.test(username)
    ) {
      return setError(
        input,
        output,
        'A Gmail username may only contain letters, numbers and full stops.'
      );
    }

    if (
      domain === 'gmail.com' &&
      (
        username.startsWith('.') ||
        username.endsWith('.') ||
        username.includes('..')
      )
    ) {
      return setError(
        input,
        output,
        'The Gmail username contains an invalid full stop.'
      );
    }

    return setValid(input, output);
  }

  function validatePhone(input) {
    const elements = getElements(input);

    if (!elements) {
      return false;
    }

    const output = elements.phoneError;
    const originalValue = input.value.trim();

    /*
     * Allow spaces, brackets and hyphens in the entered number,
     * but remove them before testing the number.
     */
    const normalisedValue = originalValue.replace(
      /[\s()\-]/g,
      ''
    );

    const phonePattern = /^\+?[0-9]{7,15}$/;

    if (originalValue === '') {
      clearResult(input, output);
      return false;
    }

    if (!phonePattern.test(normalisedValue)) {
      return setError(
        input,
        output,
        'Enter a valid phone number containing 7 to 15 digits.'
      );
    }

    return setValid(input, output);
  }

  /*
   * Delegated input validation continues working when Shopify
   * reloads the block in the theme editor.
   */
  document.addEventListener('input', function (event) {
    const input = event.target;

    if (!(input instanceof HTMLInputElement)) {
      return;
    }

    if (
      input.matches(
        '[data-event-product-block] [name="properties[Email]"]'
      )
    ) {
      validateEmail(input);
    }

    if (
      input.matches(
        '[data-event-product-block] [name="properties[Phone]"]'
      )
    ) {
      validatePhone(input);
    }
  });

  /*
   * Capture the submission before the theme's AJAX cart
   * code handles it.
   */
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) {
        return;
      }

      const block = form.closest('[data-event-product-block]');

      if (!block) {
        return;
      }

      const emailInput = form.querySelector(
        '[name="properties[Email]"]'
      );

      const phoneInput = form.querySelector(
        '[name="properties[Phone]"]'
      );

      if (!emailInput || !phoneInput) {
        return;
      }

      const emailValid = validateEmail(emailInput);
      const phoneValid = validatePhone(phoneInput);

      if (
        !emailValid ||
        !phoneValid ||
        !form.checkValidity()
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const firstInvalid = form.querySelector(':invalid');

        if (firstInvalid) {
          firstInvalid.focus();
          firstInvalid.reportValidity();
        }
      }
    },
    true
  );

    function getSelectedOptionValues(picker) {
    const values = [];

    /*
     * Radio/button options used by Boost.
     */
    picker
      .querySelectorAll('input[type="radio"]:checked')
      .forEach(function (input) {
        values.push(input.value);
      });

    /*
     * Dropdown options used by Boost.
     */
    picker.querySelectorAll('select').forEach(function (select) {
      if (select.value) {
        values.push(select.value);
      }
    });

    return values.map(function (value) {
      return String(value).trim();
    });
  }

  function findMatchingVariant(form, selectedValues) {
    const variantMap = form.querySelector(
      '[data-event-variant-map]'
    );

    if (!variantMap) {
      return null;
    }

    const variants = Array.from(variantMap.options);

    return variants.find(function (variantOption) {
      let variantValues;

      try {
        variantValues = JSON.parse(
          variantOption.dataset.options
        );
      } catch (error) {
        return false;
      }

      variantValues = variantValues.map(function (value) {
        return String(value).trim();
      });

      if (variantValues.length !== selectedValues.length) {
        return false;
      }

      return variantValues.every(function (value, index) {
        return value === selectedValues[index];
      });
    }) || null;
  }

  function updateEmbeddedVariant(picker) {
    const form = picker.closest('form');

    if (!form) {
      return;
    }

    const variantInput = form.querySelector(
      '[data-event-variant-id]'
    );

    const submitButton = form.querySelector(
      '[data-event-submit]'
    );

    const selectedValues = getSelectedOptionValues(picker);

    const matchingVariant = findMatchingVariant(
      form,
      selectedValues
    );

    /*
     * No product variant exists for this option combination.
     */
    if (!matchingVariant) {
      if (variantInput) {
        variantInput.value = '';
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent =
          submitButton.dataset.soldOutText || 'Unavailable';
      }

      return;
    }

    const available =
      matchingVariant.dataset.available === 'true';

    if (variantInput) {
      variantInput.value = matchingVariant.value;
    }

    if (submitButton) {
      submitButton.disabled = !available;

      submitButton.textContent = available
        ? submitButton.dataset.availableText
        : submitButton.dataset.soldOutText;
    }
  }

  document.addEventListener('change', function (event) {
    const picker = event.target.closest(
      '.custom-pink-variant-picker'
    );

    if (!picker) {
      return;
    }

    updateEmbeddedVariant(picker);
  }); 

})();
  } catch(e) { console.error(e); }
})();

})();
